<template>
  <div class="label-group" v-if="dataDetails.type !== ('out_text' || 'csv_selector')">
    <label for="label">Label</label><br><br>
    <Textarea id="label" rows="3" v-model="dataDetails.text" />
  </div>

  <div class="hookid-group" v-if="dataDetails.type !== 'reg_text'">
    <label for="hookId">Hook Id</label><br><br>
    <InputText id="hookId" v-model="dataDetails.hookId" />
  </div>

  <div class="checkbox-group" v-if="dataDetails.type === 'out_text'">
    <Checkbox v-model="dataDetails.compact" :binary="true" style="margin-right: 10px"/>
    <label for="label">Compact # Formatting</label>
  </div>

  <div class="currency-group" v-if="dataDetails.type === 'currency_input' || dataDetails.compact">
    <label for="currency">Currency</label><br><br>
    <AutoComplete v-model="dataDetails.currency" :suggestions="filteredCurrencies" @complete="searchCurrencies" /><br><br>
    <label for="locale">Locale</label><br><br>
    <AutoComplete v-model="dataDetails.locale" :suggestions="filteredLocales" @complete="searchLocales" /><br><br>
  </div>

  <div v-if="dataDetails.type === 'input_number'">
    <div class="numerical-input-options">
      <label for="min">Min</label><br><br>
      <InputNumber id="min" v-model="dataDetails.min" /><br><br>
      <label for="max">Max</label><br><br>
      <InputNumber id="max" v-model="dataDetails.max" /><br><br>
      <label for="step">Step</label><br><br>
      <InputNumber id="step" v-model="dataDetails.step" /><br><br>
    </div>
  </div>
</template>


<script setup lang="ts">
import { ref, onMounted } from 'vue'

const dataDetails = ref({
  hookId: '',
  type: '',
  text: '',
  compact: false,
  min: 0,
  max: 1000,
  step: 1,
  currency: 'USD',
  locale: 'en_US'
})
const currencies = ref()
const filteredCurrencies = ref()

const locales = ref()
const filteredLocales = ref()

onMounted(() => {
  window.addEventListener('invokeDataPanel', (event) => {
    dataDetails.value = event.detail
  })

  // TODO: Api to get these values
  currencies.value = ['USD', 'INR', 'EUR']
  locales.value = ['en-US', 'en-IN', 'en-GB']

})
const searchCurrencies = (event) => {
  setTimeout(() => {
    if (!event.query.trim().length) {
      filteredCurrencies.value = [...currencies.value]
    }
    else {
      filteredCurrencies.value = currencies.value.filter((currency) => {
        return currency.toLowerCase().startsWith(event.query.toLowerCase())
      })
    }
  }, 250)
}

const searchLocales = (event) => {
  setTimeout(() => {
    if (!event.query.trim().length) {
      filteredLocales.value = [...locales.value]
    }
    else {
      filteredLocales.value = locales.value.filter((locale) => {
        return locale.toLowerCase().startsWith(event.query.toLowerCase())
      })
    }
  }, 250)
}

</script>

<style lang="scss" scoped>
.checkbox-group {
  display: flex;
  align-items: center;
  margin: 10px 10px 10px 0;
}

.label-group, .hookid-group {
  margin: 0 0 10px 0;
}
</style>